<template lang="html">
  <div>
    <NavBar></navBar>
    <header-interna>
      <header slot="body" style="padding: 100px 0 30px 0;">
        <img :src="$utils.config.static + 'img/icons/header/login.svg'" width="46">
        <h1>{{ $t('finalizacao-pagamento-paypal.titulo') }}</h1>
      </header>
    </header-interna>

    <section class="branco">
      <div class="container" slot="body">
        <div v-if="!dados.erro">
          <div v-if="dados.confirmado">
            <p>{{ $('finalizacao-pagamento-paypal.pagamento-realizado') }}</p>
            <p>{{ $('finalizacao-pagamento-paypal.mais-informacoes') }}</p>
          </div>
          <div v-else>
            <p>{{ $t('finalizacao-pagamento-paypal.pagamento-pendente-aprovacao') }}</p>
            <p>{{ $t('finalizacao-pagamento-paypal.pagamento-pendente-informacoes') }}</p>
          </div>
          <a class="btn-verde" :href="dados.linkEvento">{{ $t('finalizacao-pagamento-paypal.voltar-para-site') }}</a>
        </div>
        <div v-else-if="dados.erro == 2">
          <p>{{ $('finalizacao-pagamento-paypal.pagamento-nao-autorizado') }}</p>
          <a class="btn-verde" :href="dados.urlAmbientePaypal">{{ $t('finalizacao-pagamento-paypal.tentar-novamente') }}</a>
          <a class="btn-verde" :href="dados.linkEvento">{{ $t('finalizacao-pagamento-paypal.voltar-para-site') }}</a>
        </div>
        <div v-else>
          <p>{{ $t('finalizacao-pagamento-paypal.erro-inesperado') }}</p>
          <a class="btn-verde" :href="dados.linkEvento">{{ $t('finalizacao-pagamento-paypal.voltar-para-site') }}</a>
        </div>
      </div>
    </section>

    <footer-doity-alternativo/>

  </div>
</template>

<script>
export default {
  data () {
    return {
      dados: {
        erro: true,
        confirmado: false,
        linkEvento: this.$utils.config.basePath,
        urlAmbientePaypal: this.$utils.config.basePath
      }
    }
  },
  mounted () {
    this.$apiDoity.usuarios.finalizacaoPagamentoPaypal(this.$route.query.token, this.$route.query.playerID).then(data => {
      this.dados = Object.assign({}, this.dados, data)
    })
  }
}
</script>

<style lang="scss" scoped>

  section {
    padding: 80px 0;
    text-align: center;
    background-color: white;
    color: $color-preto;
  }

  h4 {
    font-size: 19px;
    font-family: $proxima-nova-semi-bold;
  }

  h4 ~ h4 {
    margin-top: 45px;
  }

  p {
    font-size: 19px;
    line-height: 1.4;

    b {
      font-family: $proxima-nova-semi-bold;
    }
  }

  @media (min-width: 1100px) {
    .container {
      width: 1100px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/FinalizacaoPagamentoPaypal.vue